(function($) {


    function calculateDecorHeight() {
        $signpostingHeight = $("section.leisure-signposting").outerHeight();
        $firstTextHeight = $("section.text-component").outerHeight();
        $newHeight = ($signpostingHeight + $firstTextHeight) + 250;
        $(".leisure-top-decoration").css("height", $newHeight+"px")
    }
    $(window).on("load resize", function () {
        calculateDecorHeight();
    });


})( jQuery );
